import { useEffect, useState } from "react"
import { database } from "../../../../firebase"

import ImgCard from "./ImgCard"
import ImageSorting from "./ImageSorting/ImageSorting"
import "./ImgCardContainer.css"

const image = require("./images/data1.json")

const ImgCardContainer = () => {
  const images = []
  const [arr, setarr] = useState([])

  useEffect(async () => {
    database.gallery.orderBy("name", "asc").onSnapshot((querySnapshot) => {
      const arr1 = []
      querySnapshot.forEach((doc) => {
        const { URL } = doc.data()
        arr1.push(URL)
      })
      setarr(arr1)
    })
  }, [])

  const createImagesObject = () => {
    image.forEach((_, i) => {
      images[i] = {
        img: arr[i],
        description: image[i].description,
        id: i + Math.random()
      }
    })
    return images
  }
  const [newSet, setNewSet] = useState(createImagesObject())

  return (
    <div className="ImgCardContainer">
      <ImageSorting
        optionSelect={(value) =>
          value === "All"
            ? setNewSet(images)
            : setNewSet(
                images.filter((element) => element.description === value)
              )
        }
      />
      <div className="ImgCardGroup">
        {newSet.map((element) => (
          <ImgCard key={element.id} element={element} />
        ))}
      </div>
    </div>
  )
}

export default ImgCardContainer
